import { Component, h } from '@stencil/core';
import { _BREAKPOINTS_ } from 'utils';
import { initTables } from 'global/app-global/app-tables';
import { fadeIn, fadeOut } from 'global/animation/animation';
import { ImageLoader } from 'global/image-loader';

declare global {
  interface Window { imageLoader: any; }
}

declare var assetPath;

@Component({
  tag: 'kdx-app',
  shadow: false
})
export class StApp {

  componentWillLoad() {
    globalThis.imageLoader = new ImageLoader();
    this.addListItemBullets();
    this.globalFunctions();
  }

  componentDidLoad() {
    globalThis.imageLoader?.initialize();
    globalThis.init_tables();    
  }

  componentDidRender() {
    setTimeout(() => {
      var hash = window.location.hash;
      if (hash) {
        var elem = document.getElementById(hash.substring(1));
        if (elem) {
        elem.scrollIntoView();
        }
      }
    }, 500);
  }

  addListItemBullets() {
    document.head.insertAdjacentHTML("beforeend", `<style>ul.checkmarks li::before {
      --check-image: url("${assetPath}/icon/checkmark.svg");
      -webkit-mask-image: var(--check-image);
              mask-image: var(--check-image);
      -webkit-mask-position: center;
              mask-position: center;
      -webkit-mask-repeat: no-repeat;
              mask-repeat: no-repeat;
      -webkit-mask-size: contain;
              mask-size: contain;
    }</style>`);
  }

  globalFunctions() {
    /**
     * Given an array of HTML Elements, finds the
     * largest and locks the height of all elements
     * to this value
     * 
     * @param elements Array<HTMLElement>
     */
    globalThis.fix_element_height = (root) => {
      if (Array.from(root.querySelectorAll('.kdx-fix-element-height')).length) {
        const elements: Array<HTMLElement> = Array.from(root.querySelectorAll('.kdx-fix-element-height'));
        let maxHeight: number = -1;

        elements.forEach((element) => {
          // we also need the height of hidden elements in this list
          if (getComputedStyle(element).display === 'none') { 
            // add a clone to the DOM, off-screen,
            // so we can figure out the height of element
            const clone: HTMLElement = element.cloneNode(true) as HTMLElement;
            clone.setAttribute('style', 'position: absolute; display: block; visibility: hidden; top: -100%; left: -100%');
            document.body.append(clone);

            (clone.getBoundingClientRect().height > maxHeight) && (maxHeight = clone.getBoundingClientRect().height);

            // be sure to remove the clone once 
            // you're done
            clone.remove();
          } else {
            (element.clientHeight > maxHeight) && (maxHeight = element.clientHeight);
          }        
        });

        elements.forEach((element) => {
          element.setAttribute('style', `height: ${maxHeight}px`);
        });
      }
    };

    globalThis.init_tables = initTables;
    globalThis.fade_in = fadeIn;
    globalThis.fade_out = fadeOut;
  }
  
  render() {
    return (
      <div class="app-global">
        <slot />
      </div>
    )
  }
}
